import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icons from '@fortawesome/free-regular-svg-icons';
import * as icons_solid from '@fortawesome/free-solid-svg-icons';
import { generateClient } from '@aws-amplify/api';
import { getAgentSettings as _getAgentSettings } from '@/graphql/queries';
import { launchAgent as _launchAgent } from '@/graphql/mutations';
import ErrorModal from '@/ErrorModal';
import { phoneField, selectField } from '@/commonFields';
import AudioPlayer from '@/components/AudioPlayer';

const client = generateClient();

const NULL_AGENT_SETTING = {
	agent_name: 'None',
	id: null
};

const getAgentSettings = () => {
	return client.graphql({ query: _getAgentSettings })
		.then(response => {
			return [
				NULL_AGENT_SETTING,
				...response.data.getAgentSettings.agent_settings
			];
		});
};

export default ({ data }) => {
	const [errorMessage, setErrorMessage] = useState();
	const [model, setModel] = useState({ agent_name: 'openpath_transfer' });
	const get_value = useCallback(({ name }) => model[name], [JSON.stringify(model)]);
	const set_value = useCallback(({ name, value }) => setModel({ ...model, [name]: value }), [JSON.stringify(model)]);
	const [progress, setProgress] = useState([]);

	const catchError = error => {
		if (error instanceof Error) {
			setErrorMessage(error.toString());
		} else {
			setErrorMessage((error.errors || []).map(e => e.message?.toString()));
		}
	};

	const agent_progress = [
		{ text: 'Dialing agent...', delay: 12000 },
		{ text: 'Relaying summary...', delay: 20000 },
		{ text: 'Connecting call to subject' }
	];

	const launchAgent = ({ agent_name, contact_id, transfer_phone_number }) => {
		try {
			if (!agent_name) throw new Error('Must supply agent_name');
			if (!contact_id) throw new Error('Must supply contact_id');
			if (!transfer_phone_number) throw new Error('Must supply transfer_phone_number');
			const _setProgress = i => () => {
				setProgress(prevState => [...prevState, agent_progress[i].text]);
				if (agent_progress[i].delay && i < agent_progress.length - 1) setTimeout(_setProgress(i + 1), agent_progress[i].delay);
			};
			_setProgress(0)();
			return client.graphql({ query: _launchAgent, variables: { agent_name, contact_id, demo: true, transfer_phone_number } })
				.then(response => {
					return response;
				})
				.catch(catchError);
		} catch (error) {
			console.error(error);
			catchError(error);
		}
	};

	return (
		<>
			{errorMessage && <ErrorModal message={errorMessage} onClose={() => setErrorMessage()} title="Error" />}
			<div>
				<div className="row">
					{/*
					<div className="col-auto">
						<div className="form-group">
							<label className="small mb-2"><b>Start</b></label>
							<div className="form-control">{moment(data?.started_at).format('M/DD/YYYY h:mm:ss A')}</div>
						</div>
					</div>
					<div className="col-auto pe-4">
						{data?.wss_url && (
							<div className="form-group">
								<label className="small mb-2"><b>Audio</b></label>
								<AudioPlayer wsUrl={data?.wss_url} />
							</div>
						)}
					</div>
					*/}
					<div className="col">
						<div className="row">
							{/*
							<div className="col">
								{selectField({ defaultOptions: [NULL_AGENT_SETTING.agent_name], get: get_value, getData: getAgentSettings, set: set_value, key: 'agent_settings', label: 'Agent Name', name: 'agent_name', label1Key: 'agent_name', idKey: 'agent_name', valueKey: 'agent_name' })}
							</div>
							*/}
							<div className="col">
								{phoneField({ get: get_value, set: set_value, label: 'Transfer Phone Number', name: 'transfer_phone_number' })}
							</div>
						</div>
						<div className="text-end">
							<button className="btn btn-primary" disabled={progress.length > 0 || !(model.agent_name?.trim().length > 0 && model.agent_name !== NULL_AGENT_SETTING.agent_name && model.transfer_phone_number?.trim().length > 0)} onClick={() => launchAgent({ agent_name: model.agent_name, contact_id: data.contact_id, transfer_phone_number: model.transfer_phone_number })}>Launch Agent</button>
						</div>
					</div>
				</div>
				{progress.length > 0 && <hr />}
				{(progress || []).map((e, i) => <div className="row px-3" key={i}>{e}</div>)}
			</div>
		</>
	);
};
